import React from "react";

const DimensionsCellRenderer = (props) => {
    const { value } = props;

    return (
        <div className="double-renderer-outer">
          <div className="double-renderer-field">
              {value} KJ
          </div>
        </div>
    );
};

export default DimensionsCellRenderer;
